import { useLanguage } from '../utils/LanguageContext';
import translations from './AccountSettings/AccountSettings.lang.json';
import { isEmptyObject } from './common/util';
import { ItemView } from './common/CommonComponents';
import { useAuth } from '../utils/AuthContext.js';

const getAddressItem = (address, lang) => ({
  field: 'address',
  value: isEmptyObject(address) ? (
    lang('noAddressRecord')
  ) : (
    <>
      {address.street}
      <br />
      {address.unit && (
        <>
          {address.unit}
          <br />
        </>
      )}
      {[address.city, address.state, address.zip].join(', ')}
      <br />
      {address.country}
    </>
  ),
});

const AddressView = () => {
  const { lang } = useLanguage(translations);
  const { user } = useAuth();

  const items = [getAddressItem(user?.address, lang)];

  return <ItemView items={items} />;
};

export { getAddressItem };
export default AddressView;
